var Backbone, SupportProgressBarView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportProgressBarView = (function(superClass) {
  extend(SupportProgressBarView, superClass);

  function SupportProgressBarView() {
    return SupportProgressBarView.__super__.constructor.apply(this, arguments);
  }

  SupportProgressBarView.prototype.tagName = 'ol';

  SupportProgressBarView.prototype.className = 'steps';

  SupportProgressBarView.prototype.initialize = function() {
    return this.I18nScope = 'modules.support';
  };

  SupportProgressBarView.prototype.render = function() {
    var results, x;
    x = 1;
    if (Groupon.Support.MAXINDEX === void 0) {
      Groupon.Support.MAXINDEX = 0;
    }
    results = [];
    while (!(x > Groupon.Support.MAXINDEX)) {
      if (x <= Groupon.Support.CURRENTVIEW.id) {
        this.$el.append("<li class='active c-bg-prim'><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      } else {
        this.$el.append("<li><a class = 'progressBar' href='javascript:;'>" + x + "</a></li>");
      }
      results.push(++x);
    }
    return results;
  };

  return SupportProgressBarView;

})(Backbone.View);

module.exports = SupportProgressBarView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvcHJvZ3Jlc3NfYmFyX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvcHJvZ3Jlc3NfYmFyX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsZ0NBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7bUNBQ0osT0FBQSxHQUFTOzttQ0FDVCxTQUFBLEdBQVc7O21DQUVYLFVBQUEsR0FBWSxTQUFBO1dBQ1YsSUFBQyxDQUFBLFNBQUQsR0FBYTtFQURIOzttQ0FHWixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxDQUFBLEdBQUk7SUFDSixJQUFHLE9BQU8sQ0FBQyxPQUFPLENBQUMsUUFBaEIsS0FBNEIsTUFBL0I7TUFDRSxPQUFPLENBQUMsT0FBTyxDQUFDLFFBQWhCLEdBQTJCLEVBRDdCOztBQUdBO1dBQUEsQ0FBQSxDQUFNLENBQUEsR0FBSSxPQUFPLENBQUMsT0FBTyxDQUFDLFFBQTFCLENBQUE7TUFDRSxJQUFHLENBQUEsSUFBSyxPQUFPLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxFQUFwQztRQUNFLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLDRFQUFBLEdBQTZFLENBQTdFLEdBQStFLFdBQTNGLEVBREY7T0FBQSxNQUFBO1FBR0UsSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksbURBQUEsR0FBb0QsQ0FBcEQsR0FBc0QsV0FBbEUsRUFIRjs7bUJBSUEsRUFBRTtJQUxKLENBQUE7O0VBTE07Ozs7R0FQMkIsUUFBUSxDQUFDOztBQW1COUMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
